//Content.js
import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import {globalConfig} from '../../config/config';
import HomePage from '../eqius/HomePage';

function HomepageEqius()
{
        return (
        <>
        	<HomePage />
        	{/*
        	<iframe width="100%" frameborder="false" height="900" src={globalConfig.eqiusUrl} />
        	*/}
        </>
		)
}
export default HomepageEqius;

